<template>
  <div>
    <el-form ref="formData" :model="formData" size="small">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.fabric_label_groupSpecName') || '规格名称'"
          >
            <el-input v-model="formData.groupSpecName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.fabric_label_fabricPositionName') || '面料位置'"
          >
            <el-input v-model="formData.fabricPositionName" readonly>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('INDEX.form_label_fabricNo') || '面料编号'">
            <el-input v-model="formData.fabricNo" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="16">
          <el-form-item
            :label="$l('INDEX.form_label_fabricDisplayName') || '面料显示名称'"
          >
            <el-input v-model="formData.fabricDisplayName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('INDEX.form_label_fabricWeight') || '克重'">
            <el-input v-model="formData.weight" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_fabricWeightUnit') || '克重单位'"
          >
            <el-input v-model="formData.fabricWeightUnit" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_isSpecify') || '客户指定供应商'"
          >
            <el-input v-model="formData.v_isSpecify" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.purchase_form_label_scmCode') || '供应商'"
          >
            <el-input v-model="formData.scmName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_isCustomerProvide') || '是否客供'
            "
          >
            <el-input v-model="formData.v_isCustomerProvide" readonly>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: { orderFabricCode: { type: String, default: '' } },
  data() {
    return { formData: {} }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderFabricCode) return
      this.$api
        .pendingOrderDemandFabricDetailApi({
          orderFabricCode: this.orderFabricCode,
        })
        .then((res) => {
          this.formData = { ...res.body, weight: '', fabricWeightUnit: '' }
          const weights = this.formData.fabricWeight.split(' ')
          this.formData.weight = weights[0] || ''
          this.formData.fabricWeightUnit = weights[1] || ''
        })
    },
  },
}
</script>
